<template>
  <form novalidate @submit.prevent="submit">
    <v-text-field
      v-model="formData.title"
      v-validate="'required|min:3'"
      :error-messages="errors.collect('Title')"
      label='Title'
      data-vv-name="Title"
      prepend-icon="mdi-tag-text-outline"
    ></v-text-field>
    <v-text-field
      v-model="formData.expenseCode"
      v-validate="'required|min:8'"
      :error-messages="errors.collect('expenseCode')"
      :label="dictionary.attributes.expenseCode"
      data-vv-name="expenseCode"
      prepend-icon="mdi-barcode"
    ></v-text-field>
    <v-autocomplete
      v-model="formData.project"
      v-validate="'required'"
      :error-messages="errors.collect('Project')"
      label='Project'
      data-vv-name="Project"
      :items="projects"
      item-text="name"
      :return-object="true"
      prepend-icon="mdi-shape-outline"
      autocomplete="off"
    ></v-autocomplete>
    <v-text-field
      v-model="formData.budget"
      v-validate="'required|numeric'"
      :error-messages="errors.collect('Budget')"
      :label="dictionary.attributes.budget"
      data-vv-name="Budget"
      prepend-icon="mdi-cash"
    ></v-text-field>
    <v-row>
      <v-col cols="6">
        <v-menu
          v-model="startDateMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="formData.startDate"
              label="Start Date"
              prepend-icon="mdi-calendar-outline"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="formData.startDate"
            @input="startDateMenu = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="6">
        <v-menu
          v-model="endDateMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="formData.endDate"
              label="End Date"
              prepend-icon="mdi-calendar-outline"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="formData.endDate"
            :min="minEndDate"
            @input="endDateMenu = false">
          </v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-autocomplete
      v-model="formData.reporter"
      label="Reporter"
      :items="contacts"
      item-text="name"
      :return-object="true"
      prepend-icon="mdi-account-box-outline"
      autocomplete="off"
      v-validate="'required'"
      :error-messages="errors.collect('Reporter')"
      data-vv-name="Reporter"
    ></v-autocomplete>
    <div class="mt-5 d-flex">
      <v-spacer></v-spacer>
      <span v-if="!saving">
        <v-btn depressed text type="reset" @click="close">Close</v-btn>
        <v-btn depressed color="accent" class="ml-2" type="submit">Save</v-btn>
      </span>
      <v-btn depressed color="accent" class="ml-2" disabled v-if="saving">
        <v-progress-circular
          indeterminate
          size="12" width="1"
          class="mr-1">
        </v-progress-circular>
        <span>Saving...</span>
      </v-btn>
    </div>
  </form>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import types from '@/store/types';

export default {
  name: 'expense-form',

  $_veeValidate: {
    validator: 'new',
  },

  props: {
    formData: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data: () => ({
    saving: false,
    isvalid: false,
    startDateMenu: false,
    endDateMenu: false,
    dictionary: {
      attributes: {
        expenseCode: 'Expense Code',
        budget: 'Budget (Rs.)',
      },
    },
  }),

  computed: {
    ...mapState('db', [
      'has_projects_loaded',
      'has_contacts_loaded',
    ]),
    ...mapGetters('db', ['projects', 'contacts']),
    minEndDate() {
      const sDate = this.formData.startDate
        ? new Date(this.formData.startDate)
        : new Date();
      return sDate.toISOString();
    },
  },

  mounted() {
    this.$validator.localize('en', this.dictionary);
  },

  methods: {
    ...mapActions('db', {
      loadProjects: types.GET_PROJECTS,
      loadContacts: types.GET_CONTACTS,
      addExpense: types.CREATE_EXPENSE,
      updateExpense: types.UPDATE_EXPENSE,
    }),
    submit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.formData.reporter) {
            const { id, name } = this.formData.reporter;
            this.formData.reporter = { id, name };
          }
          if (this.formData.project) {
            const { id, name } = this.formData.project;
            this.formData.project = { id, name };
          }
          this.saving = true;
          this[this.formData.id ? 'updateExpense' : 'addExpense'](this.formData).then(
            () => {
              this.$emit('save');
            },
          ).catch(() => {}).finally(() => {
            this.saving = false;
          });
        }
      });
    },
    close() {
      this.$validator.reset();
      this.$emit('close');
    },
  },
  created() {
    if (!this.has_projects_loaded) {
      this.loadProjects();
    }
    if (!this.has_contacts_loaded) {
      this.loadContacts();
    }
  },
};
</script>
